import { getCancellationPolicy } from 'shared-utils';
import { OrderType } from '../schemas';
import { some } from '@utils/some';
import { every } from 'lodash';

export const allItemsCancellable = ({
  order,
  cancellationsEnabled,
}: {
  order?: OrderType | undefined;
  cancellationsEnabled: Partial<Record<string, boolean | null | undefined>>;
}) => {
  if (some(order?.vouchers)) {
    return false;
  }

  if (
    some(order?.items) &&
    every(
      order?.items,
      (item) => item.status === 'cancelled' || item.status === 'cancellation_failed'
    )
  ) {
    return false;
  }

  const allItemsCancellable = (order?.items || []).reduce((val, item) => {
    const type = item.type.includes('spa') ? 'spa' : item.type;
    if (!cancellationsEnabled?.[type]) {
      return false;
    }

    if (item?.cancellation_details?.is_cancellable === false) {
      return false;
    }

    if (!getCancellationPolicy(item?.bookable?.cancellation_policy).canBeCancelled) {
      return false;
    }

    return val;
  }, true);
  return allItemsCancellable;
};
